import React, { useState } from "react";
import { CognitoUser } from "amazon-cognito-identity-js";
import UserPool from "../cognitoConfig";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import axios from "axios";

import AuthLayout from "../Components/AuthLayout/AuthLayout";
import "../Components/AnalyzePanel/AnalysisPanel.scss";

const BASE_URL = "https://estimator.mantle3d.io/api";

const ConfirmSignupPage: React.FC = () => {

  const navigate = useNavigate();

  const { state } = useLocation();

  const email = state?.email;

  const firstName = state?.firstName;

  const lastName = state?.lastName;

  const [code, setCode] = useState("");

  const [loading, setLoading] = useState(false);

  const confirm = () => {

    setLoading(true);

    const user = new CognitoUser({
      Username: email,
      Pool: UserPool
    });

    user.confirmRegistration(
      code,
      true,
      async (err) => {

        if (err) {

          setLoading(false);

          alert(err.message);

        } else {

          try {

            // =====================================
            // CREATE POSTGRESQL USER ENTRY
            // =====================================

            await axios.post(
              `${BASE_URL}/users/signup/`,
              {
                EmailID: email,
                UserName: email,
                OrganizationID: 1
              }
            );

            setLoading(false);

            alert(
              "Account verified successfully."
            );

            navigate("/");

          } catch (apiError) {

            console.error(
              "POSTGRES USER CREATION ERROR:",
              apiError
            );

            setLoading(false);

            alert(
              "Cognito user created but database user creation failed."
            );
          }
        }
      }
    );
  };

  return (

    <AuthLayout>

      <form
        onSubmit={(e) => {

          e.preventDefault();

          confirm();
        }}
      >

        <div className="form-group">

          <label>
            Verification Code
          </label>

          <input
            placeholder="Enter verification code"
            value={code}
            onChange={(e) =>
              setCode(e.target.value)
            }
            required
          />

        </div>

        <Button
          className="btn btn-primary"
          variant="primary"
          style={{ cursor: "pointer" }}
          type="submit"
          disabled={loading}
        >

          {
            loading
              ? "Confirming..."
              : "Confirm"
          }

        </Button>

        <div className="create-account">

          <Link to="/">
            Back to Login
          </Link>

        </div>

      </form>

    </AuthLayout>
  );
};

export default ConfirmSignupPage;